import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography,
} from "@mui/material";
import TextField from "../FormElements/TextField";
import { styled } from "@mui/material/styles";

const OfficeLocationForm = ({ onChange, initialLocation }) => {
  const [location, setLocation] = useState({ ofcLat: "", ofcLong: "" });
  const [confirmOpen, setConfirmOpen] = useState(false);

  // ✅ Initialize once
  useEffect(() => {
    if (initialLocation) {
      setLocation(initialLocation);
      onChange(initialLocation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // only on mount

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updated = { ...location, [name]: value };
    setLocation(updated);
    onChange(updated);
  };

  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const handleConfirmAgree = () => {
    setConfirmOpen(false);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const updated = {
            ofcLat: pos.coords.latitude,
            ofcLong: pos.coords.longitude,
          };
          setLocation(updated);
          onChange(updated);
        },
        (err) => {
          console.error("Geolocation error:", err);
          alert("Failed to fetch current location. Please type manually.");
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  return (
    <Paper sx={{ padding: "24px", mt: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom>
        Office Location
      </Typography>

      <StyledInputsContainer>
        <TextField
          label="Office Latitude"
          name="ofcLat"
          type="number"
          value={location.ofcLat}
          onChange={handleChange}
        />
        <TextField
          label="Office Longitude"
          name="ofcLong"
          type="number"
          value={location.ofcLong}
          onChange={handleChange}
        />
      </StyledInputsContainer>

      <Button
        variant="outlined"
        color="primary"
        sx={{ mt: 2 }}
        onClick={handleConfirmOpen}
      >
        Use Current Location
      </Button>

      <Dialog open={confirmOpen} onClose={handleConfirmClose}>
        <DialogTitle>Confirm Office Location</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your current location will be used as your office location. 
            If you do not agree, please close this and type manually.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose}>Cancel</Button>
          <Button onClick={handleConfirmAgree} variant="contained" sx={{ color: "white" }}>
            Yes, Use Current Location
          </Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default OfficeLocationForm;

const StyledInputsContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "24px",
  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "1fr",
  },
}));
